<script>
  import { createEventDispatcher, onMount } from 'svelte'

  import userStore from '../stores/user.js'


  export let currentView
  export let drawerClosed

  const dispatch = createEventDispatcher()

  const closeDrawer = function () {
    dispatch('closeDrawer')
  }

  onMount(() => {
    userStore.maybeInit()
  })
</script>

<div class="sidebar" class:drawerClosed>
  <nav>
    <div class="logo"><h3>jot</h3></div>
    <ul>
      <li>
        <a class="greyLink" href="/app/#"
           class:current="{currentView === 'queues'}"
           on:click={closeDrawer}>
          Queues
        </a>
        {#if $userStore !== undefined}
          <ul>
            {#each $userStore.queues.filter(q => q.status === 'current') as queue (queue.queue_id)}
              <li>
                <a class="greyLink" href="{'/app/#' + queue.queue_id}"
                   class:current="{currentView === ('queues.' + queue.queue_id)}"
                   on:click={closeDrawer}>
                  <span class="label">{queue.name}</span>
                </a>
              </li>
            {/each}
          </ul>
        {/if}
      </li>
      <li>
        <form method="POST" action="/logout">
          <button>Log Out</button>
        </form>
      </li>
    </ul>
  </nav>
</div>

<style>
  nav {
    padding: 10px 0 20px 10px;
  }

  nav h3 {
    padding: 10px 20px;
    margin-bottom: 10px;
  }

  nav ul {
    display: flex;
    flex-direction: column;
  }

  nav > ul > li {
    margin-top: 10px;
  }
  nav > ul > li:first-child {
    margin-top: 0;
  }

  nav ul li a {
    display: block;

    width: 100%;
    padding: 10px 20px;
  }
  nav ul li a.current {
    padding: 9px 20px 9px 19px;

    background-color: white;
    border: 1px solid var(--border-color);
    border-right: 0;
    border-radius: 20px 0 0 20px;
  }

  nav ul li ul li a {
    display: flex;
    align-items: center;

    padding: 10px 20px 10px 30px;
  }
  nav ul li ul li a.current {
    padding: 9px 20px 9px 29px;
  }
  nav ul li ul li a > * {
    margin-right: 5px;
  }
  nav ul li ul li a > *:last-child {
    margin-right: 0;
  }
  nav ul li ul li a .label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2em;
  }

  nav ul li form button {
    width: 100%;
    padding: 10px 20px;

    border:none;

    text-align: left;
    font-weight: 300;
  }
</style>
